var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4845 2.00011C11.4054 2.00205 11.3268 2.01262 11.25 2.03161L3.125 4.17161C2.80384 4.25663 2.51963 4.44507 2.31629 4.70779C2.11294 4.97051 2.00179 5.29289 2 5.62511V12.5001C2 13.3226 2.6775 14.0001 3.5 14.0001H12.5C13.3225 14.0001 14 13.3226 14 12.5001V6.00011C14 5.17761 13.3225 4.50011 12.5 4.50011H5.8125L11.5 3.00011V4.00011H12.5V3.00011C12.5 2.43761 12.0215 1.99211 11.4845 2.00011ZM3.5 5.50011H12.5C12.783 5.50011 13 5.71711 13 6.00011V12.5001C13 12.7831 12.783 13.0001 12.5 13.0001H3.5C3.217 13.0001 3 12.7831 3 12.5001V6.00011C3 5.71711 3.217 5.50011 3.5 5.50011ZM11.25 8.50011C11.0511 8.50011 10.8603 8.57912 10.7197 8.71978C10.579 8.86043 10.5 9.05119 10.5 9.25011C10.5 9.44902 10.579 9.63978 10.7197 9.78044C10.8603 9.92109 11.0511 10.0001 11.25 10.0001C11.4489 10.0001 11.6397 9.92109 11.7803 9.78044C11.921 9.63978 12 9.44902 12 9.25011C12 9.05119 11.921 8.86043 11.7803 8.71978C11.6397 8.57912 11.4489 8.50011 11.25 8.50011Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenWallet);
export default __webpack_public_path__ + "static/media/open_wallet.e145206a.svg";
export { ForwardRef as ReactComponent };